import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=78c9f63d&scoped=true"
import script from "./MatchDetail.vue?vue&type=script&lang=js"
export * from "./MatchDetail.vue?vue&type=script&lang=js"
import style0 from "./MatchDetail.vue?vue&type=style&index=0&id=78c9f63d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9f63d",
  null
  
)

export default component.exports